export default __webpack_public_path__ + "static/media/Flag of Zimbabwe.81c76bb9.gif";